module.exports = __webpack_public_path__ + "img/papers_white.064e6407.svg";